import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Image } from 'foundations-components/transitional/components/Image';
import { findValidI18nKey } from 'pricing-pages-lib/utils/languageUtils';
import { PPUIGrid } from 'pricing-pages-ui-components/grid/PPUIGrid';
import { PPUIGridItem } from 'pricing-pages-ui-components/grid/PPUIGridItem';
import { useIsMobile } from 'pricing-pages-ui-components/hooks/useMedia';
import { Fragment, memo } from 'react';
import { getHubSpotCreditsKeyFeatures } from '../../utils/getHubSpotCreditsKeyFeatures';
import { getLocalizedImages } from './getLocalizedImages';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GridRowLayout = ({
  reverse,
  description,
  image
}) => {
  const currentOrder = reverse ? [description, image] : [image, description];
  return /*#__PURE__*/_jsx(Fragment, {
    children: currentOrder.map((item, index) => {
      return /*#__PURE__*/_jsx(PPUIGridItem, {
        inlineSize: "100%",
        children: /*#__PURE__*/_jsx(Flex, {
          justifyContent: "center",
          alignItems: "center",
          children: item
        })
      }, `item-${index}`);
    })
  });
};
const HubSpotCreditsFeatures = ({
  subscreen
}) => {
  const isMobile = useIsMobile();
  const features = getHubSpotCreditsKeyFeatures(subscreen);
  if (!features) return null;
  return /*#__PURE__*/_jsx(PPUIGrid, {
    gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
    rowGap: isMobile ? '600' : '1500',
    alignItems: "center",
    justifyItems: "center",
    children: features.map((feature, index) => {
      const descKey = findValidI18nKey([`pricingPage.pages.hubspot-credits.keyFeatures.features.${feature}.description.${subscreen}`, `pricingPage.pages.hubspot-credits.keyFeatures.features.${feature}.description.default`]);
      return /*#__PURE__*/_jsx(GridRowLayout, {
        reverse: !isMobile && index % 2 === 1,
        image: /*#__PURE__*/_jsx(Flex, {
          backgroundColor: "fill-surface-recessed",
          borderRadius: "300",
          maxInlineSize: isMobile ? 'auto' : '467px',
          maxBlockSize: isMobile ? 'auto' : '350px',
          inlineSize: "100%",
          justifyContent: "center",
          alignItems: "center",
          children: /*#__PURE__*/_jsx(Image, {
            src: getLocalizedImages(feature, subscreen)
          })
        }),
        description: /*#__PURE__*/_jsxs(View, {
          marginInlineStart: index % 2 === 0 ? '800' : '0',
          marginInlineEnd: index % 2 === 0 ? '0' : '800',
          marginInline: isMobile ? '0 !important' : undefined,
          inlineSize: "100%",
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h3",
            typography: "heading-500",
            marginBlockEnd: "400",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `pricingPage.pages.hubspot-credits.keyFeatures.features.${feature}.title`
            })
          }), descKey ? /*#__PURE__*/_jsx(Text, {
            as: "p",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: descKey
            })
          }) : null]
        })
      }, `row-${index}`);
    })
  });
};
export default /*#__PURE__*/memo(HubSpotCreditsFeatures);